import { render, staticRenderFns } from "./AddNews.vue?vue&type=template&id=16d6c071&scoped=true"
import script from "./AddNews.vue?vue&type=script&lang=js"
export * from "./AddNews.vue?vue&type=script&lang=js"
import style0 from "./AddNews.vue?vue&type=style&index=0&id=16d6c071&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d6c071",
  null
  
)

export default component.exports